const DynamicRender = ({ render, children, blankMessage="", loadingClasses, ...props }) => {
    if (render) {
        return (
            <div {...props}>
                {children}
            </div>
        );
    }
    return <span className={loadingClasses}>{blankMessage}</span>;
};

export default DynamicRender;
